<script lang="ts">
  import Monitor from '@lucide/svelte/icons/monitor';
  import Moon from '@lucide/svelte/icons/moon';
  import Sun from '@lucide/svelte/icons/sun';

  import type { ThemePreference } from '../../state/settings.svelte';
  import { strings } from '../../strings';
  import IconButton from '../../ui/IconButton.svelte';
  import Menu, { type MenuItem } from '../../ui/Menu.svelte';

  interface Props {
    value: ThemePreference;
    onchange: (value: ThemePreference) => void;
  }

  let { value, onchange }: Props = $props();

  const options = [
    { value: 'system', label: strings.themeSystem, icon: Monitor },
    { value: 'light', label: strings.themeLight, icon: Sun },
    { value: 'dark', label: strings.themeDark, icon: Moon },
  ] as const;

  const current = $derived(options.find((option) => option.value === value) ?? options[0]);
  const items: MenuItem[] = $derived(
    options.map((option) => ({
      id: option.value,
      label: option.label,
      icon: option.icon,
      kind: 'radio',
      checked: option.value === value,
      onselect: () => {
        onchange(option.value);
      },
    })),
  );
</script>

<Menu label={strings.theme} {items}>
  {#snippet trigger(props)}
    <IconButton
      label="{strings.theme}: {current.label}"
      icon={current.icon}
      tooltip="bottom"
      tooltipAlign="end"
      {...props}
    />
  {/snippet}
</Menu>
